// ===== Packages =====

import {
    Descendant,
    Editor,
    Range,
    Transforms,
}                                   from 'slate';

// ===== Enums =====

import {
    SLATE_EDITOR_REPLACEMENT_SELECTION,
}                                   from '../enums';

// ===== Constants =====

import {
    INITIAL_EDITOR_VALUE,
}                                   from '../constants/generalConstants';

const replaceSlateEditorValue = ({
    editor,
    value,
    selection = SLATE_EDITOR_REPLACEMENT_SELECTION.end,
}: {
    editor: Editor,
    value: string,
    selection?: typeof SLATE_EDITOR_REPLACEMENT_SELECTION[keyof typeof SLATE_EDITOR_REPLACEMENT_SELECTION],
}): void => {
    let nextValue: Descendant[] = INITIAL_EDITOR_VALUE;
    const previousSelection = editor.selection;

    try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed) && parsed.length > 0) {
            nextValue = parsed as Descendant[];
        }
    } catch (error) {
        nextValue = INITIAL_EDITOR_VALUE;
    }

    Editor.withoutNormalizing(editor, () => {
        for (let i = editor.children.length - 1; i >= 0; i -= 1) {
            Transforms.removeNodes(editor, { at: [i] });
        }
        Transforms.insertNodes(editor, nextValue, { at: [0] });
        if (selection === SLATE_EDITOR_REPLACEMENT_SELECTION.end) {
            Transforms.select(editor, {
                anchor: Editor.end(editor, []),
                focus: Editor.end(editor, []),
            });
        } else if (selection === SLATE_EDITOR_REPLACEMENT_SELECTION.start) {
            Transforms.select(editor, {
                anchor: Editor.start(editor, []),
                focus: Editor.start(editor, []),
            });
        } else if (selection === SLATE_EDITOR_REPLACEMENT_SELECTION.none) {
            Transforms.deselect(editor);
        } else if (
            selection === SLATE_EDITOR_REPLACEMENT_SELECTION.preserve
            && previousSelection
            && Range.isRange(previousSelection)
        ) {
            try {
                Transforms.select(editor, previousSelection);
            } catch (error) {
                Transforms.select(editor, {
                    anchor: Editor.end(editor, []),
                    focus: Editor.end(editor, []),
                });
            }
        }
    });
};

export default replaceSlateEditorValue;
